/**
 * Build an error object.
 *
 * @example
 * const myError = buildError('its broken', { usefulDataThatWillReportToSentry: true }, { moreUsefulData: 'is good' });
 */
export const buildError = (message, ...errorProps) => Object.assign(new Error(), ...errorProps, {
  message
});